import suggestionDescriptionSheetsService from '../../services/suggestion-description-sheets'

export default {
  namespaced: true,
  state: {
    suggestionDescriptionSheets: []
  },
  mutations: {
    SET_SUGGESTION_DESCRIPTION_SHEETS(state, suggestionDescriptionSheets) {
      state.suggestionDescriptionSheets = suggestionDescriptionSheets
    }
  },
  actions: {
    getSuggestionDescriptionSheets: async (context, desSheetId) => {
      const suggestionDescriptionSheets = await suggestionDescriptionSheetsService
        .getList(desSheetId)
        .catch(
          () => undefined
        )
      context.commit('SET_SUGGESTION_DESCRIPTION_SHEETS', suggestionDescriptionSheets || [])
      return suggestionDescriptionSheets;
    }
  },
  getters: {
    suggestionDescriptionSheets: state => state.suggestionDescriptionSheets
  }
}
